<template lang="html">
  <div>
    <slot>
      <div class="top-image__wrapper text-center">
        <img
          src="@/assets/images/dialog_warning_icon.svg"
          alt="CoreData Logo"
          class="top-image mx-auto"
        />
      </div>
      <BasePageTitle :title="$t('views.access_denied.access_denied')" />
      <p>{{ $t('views.access_denied.invalid_or_no_access_to_resource') }}</p>
      <v-btn color="primary mt-2" dark>
        {{ $t('views.access_denied.go_back') }}
      </v-btn>
    </slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped></style>
